import {
    PAYMENT_CHECKOUT_URL_PATH,
    PAYMENT_CUSTOMER_PORTAL_URL_PATH,
    ORGANIZATION_ACCOUNT_URL_PATH,
    PAYMENT_PRODUCT_CHECKOUT_URL_PATH,
    ORGANIZATION_DEPOSIT_URL_PATH,
    ORGANIZATION_DASHBOARD_URL_PATH
  } from "../constants/ApiConstants.js";

  import { Auth } from "aws-amplify";
  import { callApigateway } from "../api/callApi.js";


export async function createCheckoutSession() {
    try {
      // Get user attributes
      const user = await Auth.currentAuthenticatedUser();
      const user_id = user.attributes["custom:user_id"];
      let path = `/${PAYMENT_CHECKOUT_URL_PATH}/${user_id}`;
      const response = await callApigateway({
        endpoint: path,
        method: "GET",
        body: null
      })
      return response;
    } catch (error) {
      console.log("Error getting signed URL:", error);
      return null;
    }
  }


  export async function createCustomerPortalSession() {
    try {
      // Get user attributes
      const user = await Auth.currentAuthenticatedUser();
      const user_id = user.attributes["custom:user_id"];
      let path = `/${PAYMENT_CUSTOMER_PORTAL_URL_PATH}/${user_id}`;
      const response = await callApigateway({
        endpoint: path,
        method: "GET",
        body: null
      })
      return response;
    } catch (error) {
      console.log("Error getting signed URL:", error);
      return null;
    }
  }

  export async function createOrganizationAccountSession() {
    try {
      // Get user attributes
      const user = await Auth.currentAuthenticatedUser();
      const user_id = user.attributes["custom:user_id"];
      let path = `/${ORGANIZATION_ACCOUNT_URL_PATH}/${user_id}`;
      const response = await callApigateway({
        endpoint: path,
        method: "GET",
        body: null
      })
      return response;
    } catch (error) {
      console.log("Error getting signed URL:", error);
      return null;
    }
  }

  export async function createOrganizationDepositSession(amount) {
    try {
      // Get user attributes
      const user = await Auth.currentAuthenticatedUser();
      const user_id = user.attributes["custom:user_id"];
      let path = `/${ORGANIZATION_DEPOSIT_URL_PATH}/${user_id}?amount=${amount}`;
      const response = await callApigateway({
        endpoint: path,
        method: "GET",
        body: null
      })
      return response;
    } catch (error) {
      console.log("Error deposit checkout url:", error);
      return null;
    }
  }


  export async function createProductCheckoutSession(productId) {
    try {
      // Get user attributes
      const user = await Auth.currentAuthenticatedUser();
      const user_id = user.attributes["custom:user_id"];
      let path = `/${PAYMENT_PRODUCT_CHECKOUT_URL_PATH}/${productId}/${user_id}`;
      const response = await callApigateway({
        endpoint: path,
        method: "GET",
        body: null
      })
      return response;
    } catch (error) {
      console.log("Error getting signed URL:", error);
      return null;
    }
  }

  export async function createDahsboardLoginSession() {
    try {
      // Get user attributes
      const user = await Auth.currentAuthenticatedUser();
      const user_id = user.attributes["custom:user_id"];
      let path = `/${ORGANIZATION_DASHBOARD_URL_PATH}/${user_id}`;;
      const response = await callApigateway({
        endpoint: path,
        method: "GET",
        body: null
      })
      return response;
    } catch (error) {
      console.log("Error getting dashboard login url:", error);
      return null;
    }
  }
  